import { LockEventSessionsContext } from "./LockEventSessionsContext";
import useInitialize from "./useInitialize";
import useExecute from "./useExecute";
import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";
import EventSessionLockForm from "@main/event-sessions/components/EventSessionLockForm";

function useLockEventSessionsAction(index: any): any {
  const initialize = useInitialize();
  const initializeFunction = (id: number) => initialize(id);

  const onSuccessExecute = () => {
    setShowModal(false);
    index();
  };
  
  const execute = useExecute();  

  const executeFunction = () => execute(onSuccessExecute);

  const { setShowModal } = useContext(LockEventSessionsContext);

  const formRef = createRef<JSONSchemaForm>();

  const { element } = useContext(LockEventSessionsContext);

  const modalConfig = {
    context: LockEventSessionsContext,
    title: t("Lock event sessions"),
    onSubmit: () => formRef.current?.formElement.current.requestSubmit(),
  };

    /**
   * Form configuration definition
   */
    const formConfig = {
      formRef: formRef, // We pass the ref to the form
      onSubmit: () => {
        executeFunction();
      },
      element: element, // We pass the element to the form in order to render it in the modal form
      context: LockEventSessionsContext,
    };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <EventSessionLockForm formConfig={formConfig} /> 
      {t("lock_event_sessions_message")}
    </CrudModuleFactoryModal>
  );

  /** END EDIT TABLE ACTION */

  return {
    initializeFunction,
    actionTemplate,
  };
}

export default useLockEventSessionsAction;
